import React, { useEffect, useState } from "react";
import api from "../../../services/baseUrl";

const ContactDetails = ({ formData, setFormData, prevStep, nextStep }) => {
  const [errors, setErrors] = useState({
    email: "",
    phoneNum: "",
    companyName: "",
    address1: "",
    countryId: "",
  });

  const [countryList, setCountryList] = useState([]);

  useEffect(() => {
    const fetchcountryList = async () => {
      try {
        const response = await api.get("/countryList");
        const data = response.data;
        setCountryList(data);
      } catch (err) {}
    };

    fetchcountryList();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));

    // Reset the error when the user starts typing
    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: "",
    }));
  };

  const isValidEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

  const validateForm = () => {
    let formErrors = {};

    if (!formData.email) formErrors.email = "Email is required";
    if (!isValidEmail(formData.email))
      formErrors.email = "Please enter a valid email address";
    if (!formData.phoneNum) formErrors.phoneNum = "Phone Number is required";

    if (
      (formData.companyName || formData.address1) &&
      (!formData.companyName || !formData.address1)
    ) {
      if (!formData.companyName)
        formErrors.companyName = "Company Name is required";
      if (!formData.address1)
        formErrors.address1 = "Company Address is required";
    }
    if (!formData.countryId) formErrors.countryId = "Country is required";

    if (formData.categoryId !== 8) {
      if (!formData.companyName)
        formErrors.companyName =
          "Name is required for non-individual subscriber";
      if (!formData.address1)
        formErrors.address1 =
          "Address is required for non-individual subscriber";
    }

    setErrors(formErrors);
    return Object.keys(formErrors).length === 0; // Return true if no errors
  };

  const validateEmail = async () => {
    try {
      const response = await api.get(`/user/emailExists`, {
        params: { email: formData.email }, // Pass email as query param
      });

      // If the response is OK, return true
      if (response.status === 200) {
        return true;
      }
    } catch (err) {
      if (err.response && err.response.status === 400) {
        // Set the email error to the response body
        setErrors((prevErrors) => ({
          ...prevErrors,
          email: err.response.data, // Use the response body as the error message
        }));
      }
      return false;
    }
  };
  const handleNextStep = async () => {
    if (validateForm()) {
      const isEmailValid = await validateEmail(); // Wait for validateEmail to resolve
      if (isEmailValid) {
        nextStep(); // Proceed to the next step if email is valid
      }
    }
  };

  return (
    <>
      <button
        className="register1-button back-btn"
        type="button"
        onClick={prevStep}
      >
        Back
      </button>
      <h1>Create An Account</h1>
      <h2>Step&nbsp;2:&nbsp;Contact&nbsp;Details</h2>

      <form className="register1-form">
        <div>
          <div className="dialog-input-field">
            <label htmlFor="email">Email Address</label>
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
            />
            {errors.email && <span className="form-error">{errors.email}</span>}
          </div>

          <div className="dialog-input-field">
            <label htmlFor="phoneNum">Phone Number</label>
            <input
              type="text"
              name="phoneNum"
              value={formData.phoneNum}
              onChange={handleChange}
            />
            {errors.phoneNum && (
              <span className="form-error">{errors.phoneNum}</span>
            )}
          </div>

          <div className="dialog-input-field">
            <label htmlFor="companyName">Company Name</label>
            <input
              type="text"
              name="companyName"
              value={formData.companyName}
              onChange={handleChange}
            />
            {errors.companyName && (
              <span className="form-error">{errors.companyName}</span>
            )}
          </div>

          <div className="dialog-input-field">
            <label htmlFor="address1">Company Address</label>
            <input
              type="text"
              name="address1"
              value={formData.address1}
              onChange={handleChange}
            />
            {errors.address1 && (
              <span className="form-error">{errors.address1}</span>
            )}
          </div>

          <div className="dialog-input-field">
            <label htmlFor="countryId">Country of Operation</label>
            <select
              name="countryId"
              value={formData.countryId}
              onChange={handleChange}
            >
              {countryList.map((country, index) => (
                <option key={index} value={country.id}>
                  {country.name}
                </option>
              ))}
            </select>
            {errors.countryId && (
              <span className="form-error">{errors.countryId}</span>
            )}
          </div>

          <button
            className="register1-button"
            type="button"
            onClick={handleNextStep}
          >
            Next
          </button>
        </div>
      </form>
    </>
  );
};

export default ContactDetails;
